import {
  Card,
  CardBody,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledTooltip,
  NavItem,
  Nav,
  NavLink,
  Col,
  TabPane,
  TabContent,
  Row,
  Modal,
  FormFeedback,
  Input,
  FormGroup,
  Label,
  Form,
  Badge,
} from "reactstrap";
import SimpleBar from "simplebar-react";
import { Link } from "react-router-dom";
import classnames from "classnames";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { formatDate } from "src/common/date-formater";
import { useFormik } from "formik";
import * as Yup from "yup";
import { formatNumber } from "src/helpers/format_helper";
import AssignedUsers from "src/components/Common/AssignedUsers";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import { format } from "date-fns";
import { AppDispatch } from "src";
import {
  addTask,
  deleteTask,
  getTasksByPhaseId,
  updateTask,
} from "src/slices/Tasks/thunk";
import { getProjectById, getProjects } from "src/slices/Projects/thunk";
import useToast from "src/components/Common/toast";
import { resetTasks } from "src/slices/Tasks/reducer";

const Tasks = ({ project }: any) => {
  const tasks = useSelector((state: any) => state.tasks.tasks);
  const [modal, setModal] = useState(false);
  const dropdown_modal = useRef<any>(null);
  const [dropdown, setDropdown] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const users = useSelector((state: any) => state.users.users);
  const [assignedUsers, setAssignedUsers] = useState<number[]>([]);
  const [updateTaskState, setUpdateTaskState] = useState(false);
  const [taskState, setTaskState] = useState<any>();
  const loading = useSelector((state: any) => state.tasks.loading);
  const dispatch = useDispatch<AppDispatch>();
  const handleModal = () => {
    setModal(!modal);
    setUpdateTaskState(false);
    setTaskState(undefined);
    setAssignedUsers([]);
  };
  const [defaultTab, setDefaultTab] = useState(
    project.phases.length > 0 ? `${project.phases[0].id}` : "1"
  );
  const defaulttoggle = (tab: any) => {
    if (defaultTab !== tab) setDefaultTab(tab);
  };

  const taskValidation = useFormik({
    enableReinitialize: true,
    initialValues: updateTaskState
      ? {
          titulo: taskState.titulo,
          descricao: taskState.descricao,
          valor_gasto: taskState.valor_gasto,
          valor_estimado: taskState.valor_estimado,
          salvaguardas: taskState.salvaguardas,
          data_estimada: taskState.data_estimada,
          data_termino: taskState.data_termino,
          status: taskState.status,
        }
      : {
          titulo: "",
          descricao: "",
          valor_gasto: "",
          valor_estimado: "",
          salvaguardas: "",
          data_estimada: "",
          data_termino: "",
          status: "",
        },
    validationSchema: Yup.object({
      titulo: Yup.string().required("Por favor, insira o titulo"),
      valor_gasto: Yup.number().required("Por favor, insira o valor gasto"),
      valor_estimado: Yup.number().required(
        "Por favor, insira o valor estimado"
      ),
      salvaguardas: Yup.number().required("Por favor, insira as salvaguardas"),
      data_estimada: Yup.string().required("Por favor, insira a data estimada"),
      data_termino: Yup.string().required(
        "Por favor, insira a data de término"
      ),
      status: Yup.string().required("Por favor, insira o status"),
    }),
    onSubmit: async values => {
      if (updateTaskState) {
        dispatch(
          updateTask({
            ...values,
            id: taskState.id,
            assignedUsers,
            phase: Number(defaultTab),
            projecto: project.id,
          })
        );
      } else {
        dispatch(
          addTask({
            ...values,
            assignedUsers,
            projecto: project.id,
            phase: Number(defaultTab),
          })
        );
      }
      dispatch(getProjectById(project.id));
      setModal(false);
      taskValidation.resetForm();
      setAssignedUsers([]);
      setUpdateTaskState(false);
      setTaskState(undefined);
    },
  });
  function handleSearchChange(event: React.ChangeEvent<HTMLInputElement>) {
    setSearchTerm(event.target.value);
  }
  const handleUserSelection = (userId: number) => {
    setAssignedUsers(prevState =>
      prevState.includes(userId)
        ? prevState.filter(id => id !== userId)
        : [...prevState, userId]
    );
  };
  const { show, ToastComponent } = useToast();
  const handleDeleteTask = (id: number) => {
    dispatch(deleteTask(id)).then(response => {
      if (typeof response.payload === "undefined") {
        show("Erro", "Erro ao apagar tarefa.");
      } else {
        dispatch(getTasksByPhaseId(defaultTab));
      }
      dispatch(getProjectById(project.id));
    });
  };
  const handleTaskClick = (task: any) => {
    setModal(!modal);
    setUpdateTaskState(true);
    setTaskState(task);
    setAssignedUsers(
      task.assigned_users
        ? task.assigned_users.map((user: any) => user.user__id)
        : []
    );
  };

  useEffect(() => {
    dispatch(resetTasks());
    dispatch(getTasksByPhaseId(defaultTab));
  }, [defaultTab]);

  const getStatusBadge = (status: string) => {
    switch (status) {
      case "PLANEJADO":
        return { className: "bg-warning", text: "Planeado" };
      case "EMANDAMENTO":
        return { className: "badge-primary-subtle", text: "Em Andamento" };
      case "PENDENTE":
        return { className: "badge-secondary-subtle", text: "Pendente" };
      case "CONCLUIDO":
        return { className: "bg-success", text: "Concluído" };
      default:
        return { className: "badge-secondary-subtle", text: status };
    }
  };

  return (
    <Card>
      <CardBody>
        {ToastComponent}
        {/*<div className="d-flex align-items-start">
          <div className="flex-grow-1">
            <h5 className="card-title">Fases e Tarefas</h5>
          </div>
          <div className="flex-shrink-0">
            <UncontrolledDropdown className="float-end">
              <DropdownToggle
                href="#"
                className="btn btn-link text-dark shadow-none"
                tag="a"
              >
                <i className="uil uil-ellipsis-h"></i>
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-end">
                <DropdownItem href="#">Adicionar Fase</DropdownItem>
                <DropdownItem
                  onClick={() => {
                    handleModal();
                  }}
                >
                  Adicionar Tarefa
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
        </div>*/}

        <Nav tabs>
          {project.phases.map((phases: any) => (
            <NavItem key={phases.id}>
              <NavLink
                className={classnames({active: defaultTab === `${phases.id}`,})}
                onClick={() => {defaulttoggle(`${phases.id}`);}}
              >
                <span className="d-block d-sm-none">
                  <i className="fas fa-home"></i>
                </span>
                <span className="d-none d-sm-block">{phases.nome}</span>
              </NavLink>
            </NavItem>
          ))}
          {/*<div
            onClick={() => {
              handleModal();
            }}
            style={{ cursor: "pointer" }}
            className="d-flex align-items-center text-muted ms-3"
          >
            <i className="uil uil-plus"></i>
            <div>Adicionar Tarefa</div>
          </div>*/}
        </Nav>

        <div className="mb-2" />

        {project.phases.length > 0 ? (
          <SimpleBar style={{ maxHeight: "600px" }}>
            <TabContent
              activeTab={defaultTab}
              className="text-muted mt-4 mt-md-0"
            >
              {project.phases.map((phases: any) => (
                <TabPane tabId={`${phases.id}`} key={phases.id}>
                  <div className="table-responsive">
                    <table className="table align-middle table-nowrap mb-0">
                      <thead>
                        <tr>
                          <th scope="col" style={{ width: "40px" }}></th>
                          <th scope="col" style={{ width: "140px" }}>ID da Tarefa</th>
                          <th scope="col">Tarefa</th>
                          <th scope="col">Valor do Contrato</th>
                          <th scope="col">Valor Desembolsado</th>
                          <th scope="col">Status</th>
                          {/*<th scope="col" style={{ width: "140px" }}>Acção</th>*/}
                        </tr>
                      </thead>

                      <tbody>
                        {!loading ? (
                          <>
                            {Array.isArray(tasks) &&
                              tasks.map((task: any) => (
                                <tr key={task.id}>
                                  <td>
                                    <div className="form-check font-size-16">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        value=""
                                        id={`taskcheck${task.id}`}
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor={`taskcheck${task.id}`}
                                      ></label>
                                    </div>
                                  </td>
                                  <td onClick={() => handleTaskClick(task)}>
                                    <Link to="#">
                                      {phases.nome.slice(0, 2).toUpperCase()}-
                                      {task.id}
                                    </Link>
                                  </td>
                                  <td>
                                    <h5 className="font-size-14">
                                      <Link to="#" className="text-dark">
                                        {task.titulo}
                                      </Link>
                                    </h5>
                                    <p className="text-muted mb-0">
                                      {formatDate(task.data_termino)}
                                    </p>
                                  </td>
                                  <td>
                                    <p className="text-muted mb-0">
                                      {formatNumber(task.valor_estimado)} MZN
                                    </p>
                                  </td>
                                  <td>
                                    <p className="text-muted mb-0">{formatNumber(task.valor_gasto)} MZN</p>
                                  </td>
                                  {/*<td>
                                    {Array.isArray(task.assigned_users) && (
                                      <div className="avatar-group">
                                        {task.assigned_users
                                          .slice(0, 2)
                                          .map((user: any) => (
                                            <div
                                              className="avatar-group-item"
                                              key={user.user__id}
                                            >
                                              <Link
                                                to="#"
                                                className="d-inline-block"
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                id={`user${user.user__id}`}
                                              >
                                                <div className="avatar-sm">
                                                  <div className="avatar-title rounded-circle bg-primary">
                                                    {user.full_name
                                                      .slice(0, 2)
                                                      .toUpperCase()}
                                                  </div>
                                                </div>
                                                <UncontrolledTooltip
                                                  placement="top"
                                                  target={`user${user.user__id}`}
                                                >
                                                  {user.full_name}
                                                </UncontrolledTooltip>
                                              </Link>
                                            </div>
                                          ))}
                                        {task.assigned_users.length > 2 && (
                                          <div className="avatar-group-item">
                                            <div className="avatar-sm">
                                              <div className="avatar-title rounded-circle bg-secondary">
                                                +
                                                {task.assigned_users.length - 2}
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    )}
                                  </td>*/}
                                  <td>
                                    <span
                                      className={`badge ${
                                        getStatusBadge(task.status).className
                                      } font-size-12`}
                                    >
                                      {getStatusBadge(task.status).text}
                                    </span>
                                  </td>
                                  {/*<td>
                                    <UncontrolledDropdown>
                                      <DropdownToggle
                                        href="#"
                                        className="font-size-16 px-2 text-muted"
                                        tag="a"
                                      >
                                        <i className="uil uil-ellipsis-h"></i>
                                      </DropdownToggle>
                                      <DropdownMenu className="dropdown-menu-end">
                                        <DropdownItem
                                          href="#"
                                          className="text-danger"
                                          onClick={() =>
                                            handleDeleteTask(task.id)
                                          }
                                        >
                                          Apagar Tarefa
                                        </DropdownItem>
                                      </DropdownMenu>
                                    </UncontrolledDropdown>
                                  </td>*/}
                                </tr>
                              ))}
                          </>
                        ) : (
                          <tr>
                            <td style={{ width: 48 }}>
                              <p className="card-text placeholder-glow ">
                                <span
                                  style={{ width: 16 }}
                                  className="placeholder col-7"
                                ></span>{" "}
                              </p>
                            </td>
                            <td>
                              <p className="card-text placeholder-glow">
                                <span className="placeholder col-7"></span>{" "}
                              </p>
                            </td>
                            <td>
                              <p className="card-text placeholder-glow ">
                                <span className="placeholder col-7"></span>{" "}
                              </p>
                            </td>
                            <td>
                              <p className="card-text placeholder-glow">
                                <span className="placeholder col-7"></span>{" "}
                              </p>
                            </td>
                            <td>
                              <p className="card-text placeholder-glow">
                                <span className="placeholder col-7"></span>{" "}
                              </p>
                            </td>
                            <td>
                              <p className="card-text placeholder-glow">
                                <span className="placeholder col-7"></span>{" "}
                              </p>
                            </td>
                            <td>
                              <p className="card-text placeholder-glow">
                                <span className="placeholder col-7"></span>{" "}
                              </p>
                            </td>
                            <td>
                              <p className="card-text placeholder-glow">
                                <span className="placeholder col-7"></span>{" "}
                              </p>
                            </td>
                          </tr>
                        )}

                        {!loading && tasks.length === 0 && (
                          <td colSpan={10}>
                            <div>
                              Não há tarefas para esta fase,{" "}
                              <span
                                style={{
                                  cursor: "pointer",
                                  color: "#007bffe6",
                                  textDecoration: "underline",
                                }}
                                onClick={handleModal}
                              >
                                adicionar tarefas
                              </span>
                              .
                            </div>
                          </td>
                        )}
                      </tbody>
                    </table>
                  </div>
                </TabPane>
              ))}
            </TabContent>
          </SimpleBar>
        ) : (
          <p>Não há fases e tarefas para esta actividade</p>
        )}
      </CardBody>
      <Modal
        isOpen={modal}
        toggle={() => {
          setModal(!modal);
        }}
        centered={true}
        className="modal-lg"
        style={{ position: "relative" }}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0">
            {updateTaskState ? "Actualizar" : "Adicionar"} Tarefa
          </h5>
          <button
            type="button"
            onClick={() => {
              setModal(false);
              setUpdateTaskState(false);
              setTaskState(undefined);
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <Form onSubmit={taskValidation.handleSubmit}>
            <Row>
              <Col>
                <FormGroup className="mb-3">
                  <Label htmlFor="titulo">Nome</Label>
                  <Input
                    type="text"
                    className="form-control"
                    placeholder="Insira o nome da tarefa"
                    id="titulo"
                    name="titulo"
                    onChange={taskValidation.handleChange}
                    onBlur={taskValidation.handleBlur}
                    value={taskValidation.values.titulo}
                    invalid={
                      taskValidation.touched.titulo &&
                      taskValidation.errors.titulo ? true : false
                    }
                  />
                  {taskValidation.touched.titulo && taskValidation.errors.titulo ? (
                    <FormFeedback type="invalid">
                      {String(taskValidation.errors.titulo)}
                    </FormFeedback>
                  ) : null}
                </FormGroup>
              </Col>
              <Col>
                <FormGroup className="mb-3">
                  <Label htmlFor="data_estimada">Data De Início</Label>
                  <Flatpickr
                    placeholder="Selecione a data estimada"
                    options={{
                      altInput: true,
                      altFormat: "F j, Y",
                      dateFormat: "Y-m-d",
                    }}
                    value={taskValidation.values.data_estimada}
                    onChange={(date: Date[]) => {
                      const formattedDate = date.length
                        ? format(date[0], "yyyy-MM-dd")
                        : "";
                      taskValidation.setFieldValue(
                        "data_estimada",
                        formattedDate
                      );
                    }}
                    onBlur={taskValidation.handleBlur}
                    className={`form-control ${
                      taskValidation.touched.data_estimada &&
                      taskValidation.errors.data_estimada ? "invalid-field" : ""
                    }`}
                  />
                  {taskValidation.touched.data_estimada &&
                  taskValidation.errors.data_estimada ? (
                    <FormFeedback type="invalid">
                      {String(taskValidation.errors.data_estimada)}
                    </FormFeedback>
                  ) : null}
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col>
                <FormGroup className="mb-3">
                  <Label htmlFor="data_termino">Data de Término</Label>
                  <Flatpickr
                    options={{
                      altInput: true,
                      altFormat: "F j, Y",
                      dateFormat: "Y-m-d",
                    }}
                    value={taskValidation.values.data_termino}
                    onChange={(date: Date[]) => {
                      const formattedDate = date.length ? format(date[0], "yyyy-MM-dd") : "";
                      taskValidation.setFieldValue("data_termino",formattedDate);
                    }}
                    placeholder="Selecione a data de término"
                    onBlur={taskValidation.handleBlur}
                    className={`form-control ${
                      taskValidation.touched.data_termino &&
                      taskValidation.errors.data_termino ? "invalid-field" : ""
                    }`}
                  />
                  {taskValidation.touched.data_termino &&
                  taskValidation.errors.data_termino ? (
                    <FormFeedback type="invalid">
                      {String(taskValidation.errors.data_termino)}
                    </FormFeedback>
                  ) : null}
                </FormGroup>
              </Col>
              <Col>
                <FormGroup className="mb-3">
                  <Label htmlFor="status">Status</Label>
                  <Input
                    name="status"
                    placeholder="Superior"
                    type="select"
                    id="superior"
                    className="form-control"
                    onChange={taskValidation.handleChange}
                    onBlur={taskValidation.handleBlur}
                    value={taskValidation.values.status || "PLANEJADO"}
                    invalid={
                      taskValidation.touched.status &&
                      taskValidation.errors.status
                        ? true
                        : false
                    }
                  >
                    <option value="">Selecione o status</option>
                    <option value="PLANEJADO" selected>Planeada</option>
                    <option value="EMANDAMENTO">Em Andamento</option>
                    <option value="PENDENTE">Pendente</option>
                    <option value="CONCLUIDO">Concluída</option>
                  </Input>
                  {taskValidation.touched.status &&
                  taskValidation.errors.status ? (
                    <FormFeedback type="invalid">
                      {String(taskValidation.errors.status)}
                    </FormFeedback>
                  ) : null}
                </FormGroup>
              </Col>
            </Row>
            <Row>
            <Col>
                <FormGroup className="mb-3">
                  <Label htmlFor="valor_estimado">Valor do Contrato</Label>
                  <Input
                    type="number"
                    className="form-control"
                    placeholder="Insira o valor do contrato (MZN)"
                    id="valor_estimado"
                    name="valor_estimado"
                    onChange={taskValidation.handleChange}
                    onBlur={taskValidation.handleBlur}
                    value={taskValidation.values.valor_estimado}
                    invalid={
                      taskValidation.touched.valor_estimado &&
                      taskValidation.errors.valor_estimado ? true : false
                    }
                  />
                  {taskValidation.touched.valor_estimado &&
                  taskValidation.errors.valor_estimado ? (
                    <FormFeedback type="invalid">
                      {String(taskValidation.errors.valor_estimado)}
                    </FormFeedback>
                  ) : null}
                </FormGroup>
              </Col>
              <Col>
                <FormGroup className="mb-3">
                  <Label htmlFor="valor_gasto">Valor Desembolsado</Label>
                  <Input
                    type="number"
                    className="form-control"
                    placeholder="Insira o valor desembolsado (MZN)"
                    id="valor_gasto"
                    name="valor_gasto"
                    onChange={taskValidation.handleChange}
                    onBlur={taskValidation.handleBlur}
                    value={taskValidation.values.valor_gasto}
                    invalid={
                      taskValidation.touched.valor_gasto &&
                      taskValidation.errors.valor_gasto ? true : false
                    }
                  />
                  {taskValidation.touched.valor_gasto &&
                  taskValidation.errors.valor_gasto ? (
                    <FormFeedback type="invalid">
                      {String(taskValidation.errors.valor_gasto)}
                    </FormFeedback>
                  ) : null}
                </FormGroup>
              </Col>

              
              {/*<Col>
                <FormGroup className="mb-3">
                  <Label htmlFor="salvaguardas">Salvaguardas</Label>
                  <Input
                    type="number"
                    className="form-control"
                    placeholder="Insira o valor das salvaguardas (MZN)"
                    id="salvaguardas"
                    name="salvaguardas"
                    onChange={taskValidation.handleChange}
                    onBlur={taskValidation.handleBlur}
                    value={taskValidation.values.salvaguardas}
                    invalid={
                      taskValidation.touched.salvaguardas &&
                      taskValidation.errors.salvaguardas ? true : false
                    }
                  />
                  {taskValidation.touched.salvaguardas &&
                  taskValidation.errors.salvaguardas ? (
                    <FormFeedback type="invalid">
                      {String(taskValidation.errors.salvaguardas)}
                    </FormFeedback>
                  ) : null}
                </FormGroup>
              </Col>*/}
            </Row>
            <Row>
              {/*<Col>
                <FormGroup className="mb-3">
                  <Label htmlFor="valor_gasto">Atribuído a</Label>
                  {assignedUsers.length > 0 ? (
                    <div className="mb-3">
                      <div
                        className="avatar-group align-items-center w-100 btn btn-light p-1 "
                        onClick={() => setDropdown(!dropdown)}
                        style={{ height: "38px" }}
                      >
                        <AssignedUsers
                          assignedUsers={assignedUsers}
                          users={users}
                          size={24}
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="mb-3">
                      <button
                        type="button"
                        onClick={() => setDropdown(!dropdown)}
                        className="btn btn-light w-100"
                        data-toggle="modal"
                        data-target="#myModal"
                        style={{ height: "38px" }}
                      >
                        Seleccione os membros responsáveis
                      </button>
                    </div>
                  )}
                  {dropdown && (
                    <div
                      style={{
                        position: "absolute",
                        zIndex: 9999,
                        width: "80%",
                        top: "-50%",
                        margin: "0",
                      }}
                    >
                      <Card>
                        <CardBody
                          className="p-2 m-0"
                          style={{ height: "330px" }}
                        >
                          <div className="input-group border rounded">
                            <span className="input-group-text bg-transparent border-0 pr-1">
                              <i className="uil uil-search"></i>
                            </span>
                            <Input
                              type="text"
                              className="form-control border-0"
                              placeholder="Pesquisar"
                              value={searchTerm}
                              onChange={handleSearchChange}
                            />
                          </div>
                          <div className="my-3 px-2">
                            <p>Atribuir a</p>
                          </div>
                          <SimpleBar style={{ maxHeight: "220px" }}>
                            {users
                              .filter(
                                (user: any) =>
                                  user.unityuser__unidade__id ===
                                  project.unidade
                              )
                              .map((user: any) => (
                                <div
                                  key={user.id}
                                  className="d-flex align-items-center mb-2 p-2"
                                >
                                  <Input
                                    type="checkbox"
                                    id={`userCheckbox${user.id}`}
                                    name="selectedUsers"
                                    value={user.id}
                                    style={{ marginRight: "10px" }}
                                    checked={assignedUsers.includes(user.id)}
                                    onChange={() =>
                                      handleUserSelection(user.id)
                                    }
                                  />
                                  <Label
                                    htmlFor={`userCheckbox${user.id}`}
                                    className="ml-2 mb-0"
                                    style={{
                                      fontWeight: "500",
                                      cursor: "pointer",
                                    }}
                                  >
                                    {user.first_name} {user.last_name}
                                  </Label>
                                </div>
                              ))}
                          </SimpleBar>
                        </CardBody>
                      </Card>
                    </div>
                  )}

                  {taskValidation.touched.valor_gasto &&
                  taskValidation.errors.valor_gasto ? (
                    <FormFeedback type="invalid">
                      {String(taskValidation.errors.valor_gasto)}
                    </FormFeedback>
                  ) : null}
                </FormGroup>
              </Col>*/}
              
            </Row>
            <Row>
              <Col>
                <FormGroup className="mb-3">
                  <Label htmlFor="descricao">Descrição</Label>
                  <Input
                    type="textarea"
                    className="form-control"
                    id="descricao"
                    name="descricao"
                    placeholder="Insira a descrição da tarefa"
                    onChange={taskValidation.handleChange}
                    onBlur={taskValidation.handleBlur}
                    value={taskValidation.values.descricao}
                  />
                </FormGroup>
              </Col>
            </Row>
          </Form>
        </div>
        {dropdown && (
          <div
            style={{
              position: "fixed",
              left: 0,
              right: 0,
              top: 0,
              bottom: 0,
            }}
            onClick={() => setDropdown(false)}
          ></div>
        )}
        <div className="d-flex justify-content-end gap-2 modal-footer">
          {updateTaskState ? (
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => {
                handleDeleteTask(taskState.id);
                setModal(false);
              }}
            >
              Apagar
            </button>
          ) : (
            <button type="button" className="btn btn-secondary" onClick={() => {setModal(false);}}>Cancelar</button>
          )}
          <button onClick={() => {taskValidation.handleSubmit();}} className="btn btn-primary">Salvar</button>
        </div>
      </Modal>
    </Card>
  );
};

export default Tasks;
